// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2Uvas","signatureButtonsRight":"ModalSign_signatureButtonsRight__hCdDI"};